import React, { Fragment, useEffect, useRef, useState } from "react";
import AgGridDatasheet from "./AgGridDatasheet";
import { H3 } from "../../../AbstractElements";
import { defaultUserType, thousandSeparator } from '../../api/helper';
import { Plus, Trash2, XCircle } from "react-feather";
import fetchWrapper from '../../api/fetchWrapper';
import { API_URL } from '../../Config/Config';
import { toast } from "react-toastify";
import { uuidGenerator } from "./ghgHelper";
import { useSelector } from "react-redux";
import moment from "moment";
import { alertFunction, notifyFunction, storeData, deleteCacheData, getCacheData } from "./ghgHelper";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { PiFileArrowDownDuotone } from "react-icons/pi";

let error = false;
const PurchasedGases = ({ setSteps, preData, timeStamp, setPurchasedGases, purchasedGases, requestId, setRequestId, mode }) => {
    const [data, setData] = useState([]);
    const [noOfRow, setNoOfRow] = useState(1);
    const [loading, setLoading] = useState(false);
    const [gasData, setGasData] = useState([]);
    const [gasesArray, setGasesArray] = useState([]);
    const purchasedRef = useRef();
    const [rowIndex, setRowIndex] = useState([]);
    const [isUpdate, setUpdate] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const userProfile = useSelector(state => state?.user?.userDetails);
    const [cacheData, setCacheData] = useState()
    const keyObject = {
        customerId: userProfile?.org,
        userId: userProfile?.id,
        ...preData
    }

    const getGasData = async () => {
        await fetchWrapper(`${API_URL}/emissionunits/PurchasedGases/${preData?.countryCode}`)
            .then((res) => {
                const data = res.json;
                setGasData(data);
                const gases = data?.filter(ele => ele?.availablePurchasedGases === true)
                    .map((item) => item.gas);
                setGasesArray(gases);
            }, (err) => console.log(err))
    }

    const populateTable = (currentData) => {
        let count = currentData?.length < 10 ? (10 - currentData?.length) : 0;
        let tempData = [...currentData, ...[...Array(count)].map((_, index) => ({
            id: index + 1, isInsert: false,
            isUpdate: false, isDelete: false, isSubmit: false
        }))];
        setData(tempData)
    }

    const loadData = (savedData, cTimestamp) => {
        if (purchasedGases?.length > 0 && (savedData?.length === 0 || !savedData)) {
            populateTable(purchasedGases)
        } else if (purchasedGases?.length === 0 && savedData?.length > 0) {
            populateTable(savedData)
        } else if (purchasedGases?.length > 0 && savedData?.length > 0) {
            if (moment(cTimestamp).isAfter(moment(timeStamp))) { //cache is latest
                alertFunction(savedData, purchasedGases, populateTable)
            } else { //saved is latest
                notifyFunction(purchasedGases, populateTable)
            }
        }
    }

    const getCache = async () => {
        let cacheData = await getCacheData(keyObject);
        setCacheData(cacheData)
        loadData(cacheData?.purchasedGasesData, cacheData?.modifiedTs)
    }

    useEffect(() => {
        getGasData()
        const obj = [...Array(10)].map((_, index) => ({
            id: index + 1, isInsert: false,
            isUpdate: false, isDelete: false, isSubmit: false
        }));
        setData(obj);
        getCache()

    }, [])

    const handleClear = async (params) => {
        const updatedRowData = data.map((row, index) => {
            return ((row.id === params.data.id) && row.isSubmit === true) ? { ...row, isDelete: true, isInsert: false, isUpdate: false } :
                ((row.id === params.data.id) && row.isSubmit === false) ?
                    { id: index + 1, isInsert: false, isUpdate: false, isDelete: false, isSubmit: false }
                    : row
        });
        const tempData = {
            ...cacheData,
            requestId: requestId,
            purchasedGasesData: updatedRowData?.filter(ele => ele?.sourceId),
            modifiedTs: moment().utc().format('YYYY-MM-DD HH:mm:ss.SSSSS')
        }
        await deleteCacheData(keyObject, tempData)
        setData(updatedRowData);
    };

    const handleUpload = async (e, params, nodeIndex) => {
        console.log(e.target.files[0])
        let dataId;
        if (typeof params?.id === 'string') {
            dataId = params.id;
        } else {
            let id = uuidGenerator();
            dataId = id;
            data[nodeIndex].id = id;
        }
        let tempData = new FormData();
        tempData.append('file', e.target.files[0]);
        const options = {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem('accessToken')}`
            },
            body: tempData
        }
        await fetchWrapper(`${API_URL}/document/uploadEvidences?category=PurchasedGases&uploadPeriod=${preData?.uploadPeriod}
            &categoryDetailId=${dataId}&year=${preData?.year}&month=${preData?.month}&quarter=${preData?.quarter}
            &requestId=${requestId ? requestId : ''}&locationId=${preData?.locationId}`, options)
            .then((res) => {
                setLoading(false)
                let tempData = [...data];
                tempData[nodeIndex].documentId = res?.json?.id;
                tempData[nodeIndex].uploadedFileName = res?.json?.uploadedFileName;
                setRequestId(res?.json?.requestId)
                tempData[nodeIndex].isInsert = true;
                tempData[nodeIndex].isUpdate = false;
                setData(tempData)
                createCache(data?.filter(ele => ele?.sourceId))
                toast.success('Evidence uploaded successfully!')
            })
            .catch((err) => {
                console.log(err)
                toast.error('Evidence upload failed!')
                setLoading(false)
            })
    }

    const downloadEvidence = async (paramsData) => {
        await fetchWrapper(`${API_URL}/document/downloadEvidence/${paramsData?.documentId}`)
            .then((err) => {
                console.log(err.json)
                if (err.status === 200) {
                    const link = document.createElement('a');
                    link.href = err?.json?.presignedUrl;
                    link.download = paramsData.uploadedFileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
                if (err.status === 500) {
                    toast.error('Something went wrong!')
                }
            })
            .catch((err) => {
                console.log(err, 'asdasd')
            })
    }

    const columnData = [
        {
            headerName: 'Source ID',
            field: 'sourceId',
            editable: false,
            valueGetter: (params) => {
                if (params.data.hasOwnProperty('gas') || params.data.hasOwnProperty('purchasedAmount')) {
                    params.data.sourceId = `PG-${params.node.rowIndex + 1}`;
                    return params.data.sourceId
                }
            },
            filter: false,
            width: 100,
            cellClass: 'disable-cell'
        },
        {
            headerName: 'Gas',
            field: 'gas',
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: gasesArray,
            },
            valueGetter: (params) => {
                if (params.data.gas) {
                    let getGasData = gasData?.find((item) => item?.gas === params.data?.gas);
                    params.data.resourceType = getGasData?.resourceType
                    return params.data.gas;
                }
            },
            editable: mode === 'Edit' ? true : false,
            cellClass: mode === 'Edit' ? '' : 'disable-cell',
            filter: false,
            flex: 2,
            sortable: false,
        },
        {
            headerName: 'Purchased Qty',
            field: 'purchasedAmount',
            filter: false,
            cellEditor: 'agNumberCellEditor',
            cellEditorParams: {
                min: 0,
                precision: 4
            },
            cellRenderer: (params) => {
                return <div className="text-right w-100">{params?.data?.purchasedAmount ? thousandSeparator(params?.data?.purchasedAmount.toFixed(4)) : ''}</div>;
            },
            flex: 1,
            editable: mode === 'Edit' ? true : false,
            cellClass: mode === 'Edit' ? '' : 'disable-cell',
        },
        {
            headerName: 'Unit',
            field: 'units',
            filter: false,
            editable: (params) => {
                if (params.data?.gas) {
                    let getGasData = gasData?.find((item) => item?.gas === params.data?.gas);
                    let unitData = getGasData?.units?.split(',');
                    if (unitData?.length > 1) {
                        return true
                    }
                } return false;
            },
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => {
                if (params.data?.gas) {
                    let getGasData = gasData?.find((item) => item?.gas === params.data?.gas);
                    let unitData = getGasData?.units?.split(',');
                    if (unitData?.length > 1) {
                        return {
                            values: unitData, // your dropdown options
                        };
                    }
                }
            },
            valueGetter: (params) => {
                if (params.data?.gas) {
                    let getGasData = gasData?.find((item) => item?.gas === params.data?.gas);
                    let unitData = getGasData?.units?.split(',');
                    if (unitData?.length === 1) {
                        params.data.units = unitData[0];
                        return unitData[0];
                    }
                }
                if (params.data?.units) {
                    return params.data?.units
                }
            },
            flex: 1,
            cellClass: mode === 'Edit' ? '' : 'disable-cell',
            sortable: false
        },
        {
            headerName: 'Evidence',
            flex: 1.5,
            autoHeight: true,
            wrapText: true,
            tooltipValueGetter: (params) => {
                if (params.data.uploadedFileName) {
                    return params.data.uploadedFileName;
                }
            },
            cellRenderer: (params) => {
                {if (mode === 'Edit') {
                    if (!params.data.uploadedFileName) {
                        return (
                            <div>
                                <label className="upload-file-icon">
                                    <input
                                        type="file" hidden accept=".jpeg, .jpg, .png, .pdf"
                                        onChange={(event) => handleUpload(event, params?.data, params?.node?.rowIndex)}
                                    />
                                    <AiOutlineCloudUpload />
                                </label>
                            </div>
                        );
                    } else {
                        return (
                            <div onClick={() => downloadEvidence(params.data)}>
                                <PiFileArrowDownDuotone className="file-download" />
                            </div>
                        )
                    }
                }}
            },
            suppressMovable: true,
            cellClass: 'tick-center'
        },
        {
            headerName: 'Clear',
            width: 70,
            cellRenderer: (params) => {
                return (
                    (params.data.sourceId && mode === 'Edit') ?
                        <div>
                            <Trash2 onClick={() => handleClear(params)}
                                className={'trash-icon mtop-0'} />
                        </div> : <></>
                )
            },
            suppressMovable: true,
            cellClass: 'icon-center'
        },
    ]

    const addingRows = (val) => {
        setNoOfRow(val)
    }

    const addRows = () => {
        const rowData = [];
        for (let i = 1; i <= noOfRow; i++) {
            rowData.push({
                id: data?.length + i, isInsert: false,
                isUpdate: false, isDelete: false, isSubmit: false
            })
        }
        setData([...data, ...rowData]);
    }

    const createCache = async (data) => {
        const tempData = {
            ...cacheData,
            purchasedGasesData: data?.filter(ele => ele?.sourceId),
            modifiedTs: moment().utc().format('YYYY-MM-DD HH:mm:ss.SSSSS')
        }
        await storeData(keyObject, tempData)
    }

    const onCellValueChanged = (event) => {
        if (event.value) {
            if (event.data.isSubmit === true && (event.data.isInsert === false || event.data.isUpdate === true)) {
                event.data.isUpdate = true;
                event.data.isInsert = false;
            } else if (event.data.isSubmit === false && event.data.isInsert === false && typeof event.data.id !== 'string') {
                event.data.id = uuidGenerator();
                event.data.isInsert = true;
                event.data.isUpdate = false;
            } else if (event.data.isSubmit === false && event.data.isInsert === false) {
                event.data.isInsert = true;
                event.data.isUpdate = false;
            }
        }
        createCache(data?.filter(ele => ele?.sourceId))
    }

    const getGridData = () => {
        if (purchasedRef.current) {
            const tableState = data
                .filter((rowNode) => (rowNode.sourceId))
                .map((rowNode, index) => {
                    if (rowNode.gas && rowNode.resourceType
                        && rowNode.purchasedAmount && rowNode.units) {
                        let data = {
                            id: rowNode.id,
                            sourceId: rowNode.sourceId,
                            gas: rowNode.gas,
                            resourceType: rowNode.resourceType,
                            purchasedAmount: parseFloat(rowNode.purchasedAmount),
                            units: rowNode.units,
                            documentId: rowNode.documentId ? rowNode.documentId : null,
                            uploadedFileName: rowNode.uploadedFileName ? rowNode.uploadedFileName : null,
                            isInsert: rowNode.isInsert,
                            isUpdate: rowNode.isUpdate,
                            isDelete: rowNode.isDelete,
                            isSubmit: rowNode.isSubmit
                        }

                        return data;
                    } else {
                        rowIndex.push(rowNode?.sourceId.split('-')[1]);
                        return {}
                    }
                });
            if (tableState?.some(ele => Object.keys(ele)?.length === 0)) {
                error = true;
            } else {
                error = false
            }
            return tableState.filter(ele => Object.keys(ele)?.length > 0);
        }
        return [];
    }

    const onSubmit = async () => {
        const gridData = getGridData();
        if (error === true) {
            toast.error(`Please fill missing values for row ${[...new Set(rowIndex)].join(',')}`)
            setRowIndex([])
            error = false;
            return
        } else {
            setPurchasedGases(gridData)
            setSteps(0);
        }
    }


    return (
        <Fragment>
            <div className="d-flex">
                <H3 attrH3={{ className: 'f-s-15' }}>Purchased Gases</H3>
                <button className="manage-asm-but border-1px-solid"
                    onClick={() => onSubmit()}>Back to Summary</button>
            </div>
            {deleteLoading ? <div className="loading-overlay"><i class="fa-solid fa-spinner fa-spin mr-1"></i> Loading....</div> : <></>}
            <div className="mtop-1" style={{ opacity: deleteLoading ? '0.2' : '1' }}>
                <div style={{ width: '100%' }} className="ag-datasheet">
                    <AgGridDatasheet
                        tableData={data?.filter(ele => ele?.isDelete === false)}
                        columnData={columnData}
                        agRef={purchasedRef}
                        onCellValueChanged={onCellValueChanged}
                    />
                    <div className="ag-custom-footer">
                        <div className="d-flex ">
                            <button className="add-row-button" onClick={addRows}><Plus className="mr-10" color="#9da6ab" fontSize={13} height={20} width={20} strokeWidth={3} />  Add</button>
                            <input
                                type="number"
                                className="ml-1 input-number"
                                value={noOfRow}
                                onChange={(e) => addingRows(e.target.value)}
                            />
                            <h5 className="ml-1">rows</h5>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    )
}

export default PurchasedGases;